module.exports = __webpack_public_path__ + "img/惊恐.0ed25734.gif";